import config from '../../config';
import baseFetch from './helpers';

export const region = ipAddress =>
  baseFetch(`${config.servicesURL}/geo-target/region?ipAddress=${ipAddress}`);

export default region;



// WEBPACK FOOTER //
// ./src/common/api/geotarget.js